import React from 'react';
import pt from 'prop-types';
import { Avatar, Stack, Typography } from '@metarouter-private/mr-mui';

import StarterKits from 'app/starterkits/starterkits-state';
import LOGO_MAP from './logos';

export default function IntegrationName({ id, TypographyProps }) {
  const { kits, kitById } = StarterKits();

  // retrieve integration starterkit from starterkits array
  const starterkit = kitById(kits, id);

  const typographyPropsWithVariant = {
    variant: 'body2',
    ...TypographyProps,
  };

  const logo = LOGO_MAP[id];

  if (!logo) {
    return (
      <Stack alignItems="center" direction="row" spacing={1}>
        <Avatar sx={{ width: 32, height: 32 }}>{id.charAt(0).toUpperCase()}</Avatar>
        <Typography component="span" {...typographyPropsWithVariant}>
          {id}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack alignItems="center" direction="row" spacing={1}>
      <Avatar src={logo} sx={{ width: 32, height: 32 }} />
      <Typography component="span" {...typographyPropsWithVariant}>
        {starterkit?.friendlyName}
      </Typography>
    </Stack>
  );
}

IntegrationName.propTypes = {
  id: pt.string.isRequired,
  TypographyProps: pt.object,
};
